import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

export default function Header() {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isMenuOpen]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled || isMenuOpen ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
        }`}
      >
        <div className="h-16 md:h-20 flex items-center justify-between px-5 md:px-12 border-b border-gray-200/50">
          <Link to="/" className="flex items-center gap-2 md:gap-3 group">
            <img
              src="https://static.readdy.ai/image/f493cbe5c2084134677121347fdba237/b70d9c49840a35cd7acb9f2db83c4db5.png"
              alt="New Age Cinema Logo"
              className="h-8 w-8 md:h-10 md:w-10 object-contain"
            />
            <div className="flex items-center gap-1.5 md:gap-2">
              <span className="text-xs md:text-sm font-light tracking-[0.2em] md:tracking-[0.3em] text-black">NEW</span>
              <div className="w-px h-3 md:h-4 bg-[#00F0FF]"></div>
              <span className="text-xs md:text-sm font-light tracking-[0.2em] md:tracking-[0.3em] text-black">AGE CINEMA</span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-12">
            <Link
              to="/works"
              className={`text-sm font-light tracking-[0.2em] relative group ${
                isActive('/works') ? 'text-black' : 'text-gray-600'
              }`}
            >
              WORKS
              <span className="absolute bottom-0 left-0 w-0 h-px bg-[#00F0FF] transition-all duration-300 group-hover:w-full"></span>
            </Link>
            <Link
              to="/about"
              className={`text-sm font-light tracking-[0.2em] relative group ${
                isActive('/about') ? 'text-black' : 'text-gray-600'
              }`}
            >
              ABOUT
              <span className="absolute bottom-0 left-0 w-0 h-px bg-[#00F0FF] transition-all duration-300 group-hover:w-full"></span>
            </Link>
            <Link
              to="/contact"
              className={`text-sm font-light tracking-[0.2em] relative group ${
                isActive('/contact') ? 'text-black' : 'text-gray-600'
              }`}
            >
              CONTACT
              <span className="absolute bottom-0 left-0 w-0 h-px bg-[#00F0FF] transition-all duration-300 group-hover:w-full"></span>
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden w-8 h-8 flex flex-col items-center justify-center gap-1.5 cursor-pointer"
            aria-label="メニュー"
          >
            <span className={`block w-5 h-px bg-black transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-[3.5px]' : ''}`}></span>
            <span className={`block w-5 h-px bg-black transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-[3.5px]' : ''}`}></span>
          </button>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <div
        className={`fixed inset-0 z-40 bg-white transition-all duration-300 md:hidden ${
          isMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
      >
        <nav className="flex flex-col items-center justify-center h-full gap-10">
          <Link
            to="/works"
            className={`text-2xl font-light tracking-[0.3em] transition-colors duration-300 ${
              isActive('/works') ? 'text-[#00F0FF]' : 'text-black'
            }`}
          >
            WORKS
          </Link>
          <Link
            to="/about"
            className={`text-2xl font-light tracking-[0.3em] transition-colors duration-300 ${
              isActive('/about') ? 'text-[#00F0FF]' : 'text-black'
            }`}
          >
            ABOUT
          </Link>
          <Link
            to="/contact"
            className={`text-2xl font-light tracking-[0.3em] transition-colors duration-300 ${
              isActive('/contact') ? 'text-[#00F0FF]' : 'text-black'
            }`}
          >
            CONTACT
          </Link>
          <div className="mt-8 flex items-center gap-6">
            <a href="#" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center">
              <i className="ri-youtube-fill text-xl text-gray-400 hover:text-[#00F0FF] transition-colors"></i>
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center">
              <i className="ri-twitter-x-fill text-xl text-gray-400 hover:text-[#00F0FF] transition-colors"></i>
            </a>
            <a href="https://www.instagram.com/eiji_hoshino?igsh=d2p4MWhlaXg2dXdu&utm_source=qr" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center">
              <i className="ri-instagram-fill text-xl text-gray-400 hover:text-[#00F0FF] transition-colors"></i>
            </a>
          </div>
        </nav>
      </div>
    </>
  );
}
